import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/kontakt-porownywarka.png'


_pushScopeId("data-v-08cda88c")
const _hoisted_1 = { class: "contact-us__form" }
const _hoisted_2 = { class: "contact-us__form--inner text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "contact-us__form--image",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "position-relative title title--small contact-us__form--title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "anchor anchor-contactForm" }, null, -1)
const _hoisted_6 = { class: "fw-medium fs-16 fs-md-21 lh-24 lh-md-27 color-font" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notus_lead_contact = _resolveComponent("notus-lead-contact")!
  const _component_notus_lead_info = _resolveComponent("notus-lead-info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h3", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.getLeadContent('FORM_TITLE', 'page.contact.form.title')), 1)
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getLeadContent('FORM_SUBTITLE', 'page.contact.form.sub_title')), 1),
      _createVNode(_component_notus_lead_contact)
    ]),
    _createVNode(_component_notus_lead_info, {
      onSubmitClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSubmitClicked()))
    })
  ]))
}